import { default as FolderContent } from './FolderContent.container';
import { withFeatureBranch } from '@wix/da-shared-react/pkg/redux/flags';
import FolderContent__premium_folders from '../FolderContent__premium_folders';

export default withFeatureBranch({
  premium_folders: FolderContent__premium_folders,
})(FolderContent);
